import { Component, Injector, inject } from '@angular/core';
import { ProgramDetailsGAService, ArchitectureService, AuthorizationService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { FilterableService } from '../../../../shared/filterable-service';

@Component({
  selector: 'app-program-details-ga',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class ProgramDetailsGaComponent extends BaseGridComponent {
  private readonly gaArchitectureService: ArchitectureService;
  private readonly gaProgramService: ProgramDetailsGAService;
  private readonly gaUserService: AuthorizationService;
  private readonly architectureDescriptionService = new FilterableService();
  private readonly programDescriptionService = new FilterableService();
  private readonly veUserService = new FilterableService();
  private readonly ergoEngineerService = new FilterableService();

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: ProgramDetailsGAService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.gaArchitectureService = injector.get(ArchitectureService);
    this.gaProgramService = injector.get(ProgramDetailsGAService);
    this.gaUserService = injector.get(AuthorizationService);

    this.appCardTitle = 'Program Details';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'ProgramCode',
        title: 'Program Code',
        type: 'dropdown',
        service: this.programDescriptionService,
        textField: 'ProgramCode',
        valueField: 'Id',
        name: 'ProgramId',
        isEditingDisabled: true,
        isEditingDisabledColumn: 'ProgramCode',
        refreshSecondaryData: this.populateProgramDetailsList,
      },
      {
        field: 'ArchitectureDescription',
        title: 'Architecture',
        type: 'dropdown',
        service: this.architectureDescriptionService,
        textField: 'Description',
        valueField: 'Id',
        name: 'ArchitectureId',
        refreshSecondaryData: this.populateArchitectureList
      },
      {
        field: 'MELeadName',
        title: 'ME Lead',
        type: 'dropdown',
        service: this.veUserService,
        textField: 'Name',
        valueField: 'Gmin',
        name: 'MELead',
        refreshSecondaryData: this.populateProgramDetailsUserList
      },
      {
        field: 'VELeadName',
        title: 'VE Lead',
        type: 'dropdown',
        service: this.veUserService,
        textField: 'Name',
        valueField: 'Gmin',
        name: 'VELead'
      },
      {
        field: 'ErgorEngineerName',
        title: 'Ergo Engineer',
        type: 'dropdown',
        service: this.ergoEngineerService,
        textField: 'Name',
        valueField: 'Gmin',
        name: 'ErgoEngineer',
        refreshSecondaryData: this.populateErgoEngineerList,
      },
      {
        field: 'IsSecure',
        title: 'Secure',
        editor: 'boolean',
        filter: 'boolean'
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      ProgramCode: [],
      ArchitectureDescription: [],
      MELeadName: [],
      VELeadName: [],
      ErgorEngineerName: [],
      VirtualBuildEngineerName: [],
      ProgramId: ['',  Validators.required],
      ArchitectureId: ['',  Validators.required],
      MELead: ['',  Validators.required],
      VELead: ['',  Validators.required],
      ErgoEngineer: [],
      VirtualBuildEngineer: [],
      IsActive: [],
      IsSecure: [],
      AuditDto: []
    });
  }

  /**
   * Architecture Helper Methods------------------------------------------------------
   */
  populateArchitectureList(dataItem: any) {
    dataItem.gaArchitectureService.read('?activeOnly=true')
    .then(result => {
      if (result.length > 0) {
        result.sort((a, b) => a.Description.localeCompare(b.Description));
      }
      dataItem.architectureDescriptionService.next(result);
    });
  }

  /**
   * Program Details Helper Methods--------------------------------------------------
   */
  populateProgramDetailsList(dataItem: any) {
    dataItem.gaProgramService.read('/corePrograms')
    .then(data => {

      const result = [];
      data.forEach(element => {
        if (element.IsActive) {
          result.unshift(element);
        }
      });

      if (result.length > 0) {
        result.sort((a, b) => a.ProgramCode.localeCompare(b.ProgramCode));
      }
      dataItem.programDescriptionService.next(result);
    });
  }

  populateProgramDetailsUserList(dataItem: any) {
    dataItem.gaUserService.read('/moduleusers?moduleName=VE_GA')
      .then(result => {
      if (result.length > 0) {
        result.sort((a, b) => a.Name.localeCompare(b.Name));
      }
      dataItem.veUserService.next(result);
    });
  }

  populateErgoEngineerList(dataItem: any) {
    dataItem.gaUserService.read('/moduleusers?moduleName=VE_GA')
      .then(result => {
      if (result.length > 0) {
        result.sort((a, b) => a.Name.localeCompare(b.Name));
      }

      const emptyUser = {
        Email: null,
        FirstName: null,
        Gmin: null,
        LastName: null,
        Name: null,
      };

      result.unshift(emptyUser);
      dataItem.ergoEngineerService.next(result);
    });
  }
}
